import { render, staticRenderFns } from "./EditPayGradeSalary.vue?vue&type=template&id=40f80fb6&scoped=true"
import script from "./EditPayGradeSalary.vue?vue&type=script&lang=js"
export * from "./EditPayGradeSalary.vue?vue&type=script&lang=js"
import style0 from "./EditPayGradeSalary.vue?vue&type=style&index=0&id=40f80fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f80fb6",
  null
  
)

export default component.exports